module.exports = __webpack_public_path__ + "img/settings_320.d824a6a5.webp";